import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/pro-light-svg-icons";
import { Tooltip, TooltipContent, TooltipTrigger } from "components/MyTooltip";

const LicenseChip = ({ name, quantity, tooltip }) => {
    return (
        <div className="flex items-center gap-2 rounded-2xl border-2 border-gray-200 bg-gray-50/50 py-0.5 px-1.5 text-sm">
            <Tooltip>
                <TooltipTrigger type="button">
                    <FontAwesomeIcon
                        className="h-4 w-4 translate-y-0.5 text-gray-700"
                        icon={faQuestionCircle}
                    />
                </TooltipTrigger>

                <TooltipContent className="Tooltip z-10 !px-4 !py-3">
                    <span
                        dangerouslySetInnerHTML={{
                            __html: tooltip ?? "",
                        }}
                    />
                </TooltipContent>
            </Tooltip>

            <span>{name}:</span>

            <span className="font-semibold">{quantity}</span>
        </div>
    );
};

export default LicenseChip;
